import React, {useEffect} from "react";
import {withStyles} from "@material-ui/core/styles";
import {
    Box,
    TextField,
    CssBaseline,
    Button,
    Snackbar,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@material-ui/core";
import Copyright from "../../commons/Copyright";
import PlatformRequest from "../../utils/PlatformRequest";
import Alert from "@material-ui/lab/Alert";
import {useHistory} from "react-router-dom";
import LoadPage from "../../components/LoadPage";
import StorageService from "../../services/StorageService";
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Theme from "../../commons/Theme";
import logo from "../../assets/logo.jpeg";
import {homePageStyles} from "../../utils/homePageStyles";

const HomePage = () => {
    const classes = homePageStyles()
    const history = useHistory()
    const [state, setState] = React.useState({
        login: "",
        password: "",
        open: false,
        vertical: "bottom",
        horizontal: "center",
    });
    const [load, setLoad] = React.useState(false);
    const storageService = new StorageService();
    const {vertical, horizontal, open} = state;
    const [accessType, setAccessType] = React.useState('PROVIDER')

    const handleChange = (event) => {
        setAccessType(event.target.value)
    }

    const verifySubmit = (event) => {
        if (event.key === "Enter") {
            submitLogin()
        }
    }

    const register = () => {
        return history.push("/register")
    }

    const redirect = () => {
        return history.push("/home")
    }

    const submitLogin = () => {
        setLoad(true);
        const {login, password} = state
        const loginBody = {
            login: login,
            password: password,
            rule: accessType
        }

        PlatformRequest.loginRequest(loginBody)
            .then((response) => {
                if (response.status === 200) {
                    storageService.saveItemLocalStorage("jwt", `Bearer ${response.body.accessToken}`)

                    if (accessType === "EMPLOYEE") {
                        PlatformRequest.getAuthEmployee()
                            .then((response) => {
                                storageService.saveItemLocalStorage("employee", JSON.stringify(response.body))
                            })
                    }

                    PlatformRequest.getAuthProvider().then((response) => {
                        storageService.saveItemLocalStorage("provider", JSON.stringify(response.body))
                        setLoad(false);
                        return redirect()
                    })
                } else {
                    setLoad(false);
                    setState({...state, open: true});
                }
            })
            .catch(() => {
                setLoad(false);
                setState({...state, open: true});
            })
    }

    const loginChange = (event) => {
        setState({
            ...state,
            login: event.target.value,
        })
    }

    const passwordChange = (event) => {
        setState({
            ...state,
            password: event.target.value,
        })
    }

    const handleClose = () => {
        setState({...state, open: false});
    }

    useEffect(() => {
        const jwt = storageService.getItemLocalStorage("jwt");

        if (jwt !== null) {
            redirect();
        }
    })

    return (
        <Theme>
            <Grid container component="main" className={classes.root}>
                <CssBaseline/>
                <Grid item xs={false} sm={4} md={7} className={classes.image}/>
                <Grid item xs={12} sm={8} md={5}
                      component={Paper}
                      elevation={6} square
                      style={{
                          backgroundColor: "#14161FFF",
                          paddingTop: 100,
                      }}>
                    <div className={classes.paper}>
                        <img src={logo} alt="Deixa Que Eu Procuro" height="150"/>
                        <br/><br/>
                        <FormControl fullWidth variant="outlined" margin="normal" className={classes.select}>
                            <InputLabel id="access-type-label">Acessar Como</InputLabel>
                            <Select
                                labelId="access-type-label"
                                id="access-type-id"
                                value={accessType}
                                label="Acessar Como"
                                onChange={handleChange}
                            >
                                <MenuItem value={"PROVIDER"}>Fornecedor</MenuItem>
                                <MenuItem value={"EMPLOYEE"}>Funcionário</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            autoFocus
                            fullWidth
                            id="login"
                            label={accessType === "PROVIDER" ? "Informe seu CNPJ": "Informe seu Whatsapp"}
                            name="login"
                            value={state.login}
                            classes={classes.root}
                            autoComplete="login"
                            className={classes.textField}
                            onChange={loginChange}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            value={state.password}
                            onKeyDown={verifySubmit}
                            onChange={passwordChange}
                            name="password"
                            label="Informe sua senha"
                            type="password"
                            id="password"
                            className={classes.textField}
                            autoComplete="current-password"
                        />
                        <Grid container>
                            <Grid item xs>
                            </Grid>
                            <Grid item>
                                <Link onClick={() => {
                                    history.push("/recover-password")
                                }}
                                      component="button"
                                      variant="body2">
                                    recuperar a senha
                                </Link>
                            </Grid>
                        </Grid>
                        <Button
                            type="click"
                            fullWidth
                            variant="contained"
                            color="primary"
                            onClick={submitLogin}
                            className={classes.submit}
                        >
                            Acessar
                        </Button>
                        <Button
                            fullWidth
                            variant="outlined"
                            color="primary"
                            onClick={register}
                        >
                            Cadastrar
                        </Button>

                        <Box mt={5}>
                            <Copyright/>
                        </Box>
                    </div>
                </Grid>

                <Snackbar
                    anchorOrigin={{vertical, horizontal}}
                    open={open}
                    onClose={handleClose}
                    key={vertical + horizontal}
                >
                    <Alert onClose={handleClose} severity="error">
                        Usuário ou senha inválidos
                    </Alert>
                </Snackbar>
                <LoadPage load={load}/>
            </Grid>
        </Theme>
    );
};
export default withStyles(homePageStyles)(HomePage);
